export const VALIDATE_USER_ENDPOINT = 'users';
